var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4261",
    "data-name": "Rect\\xE1ngulo 4261",
    width: 73.491,
    height: 95.591,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13000",
    "data-name": "Grupo 13000",
    transform: "translate(-0.089 0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12249",
    "data-name": "Grupo 12249",
    transform: "translate(26.257 22.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12248",
    "data-name": "Grupo 12248",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_866",
    "data-name": "Elipse 866",
    cx: 34.722,
    cy: 34.722,
    r: 34.722,
    transform: "translate(2.024 2.024)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_832",
    "data-name": "Trazado 832",
    d: "M1.994,57.41A34.735,34.735,0,0,1,34.35,35.31c15.467,0,28.571,8.126,33.064,22.1",
    transform: "translate(2.042 36.157)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_833",
    "data-name": "Trazado 833",
    d: "M57.895,28.646c0,12.274-11.814,22.221-26.389,22.221S5.117,40.919,5.117,28.646,18.322,11.98,32.894,11.98,57.895,16.372,57.895,28.646Z",
    transform: "translate(5.24 12.267)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4260",
    "data-name": "Rect\\xE1ngulo 4260",
    width: 28.336,
    height: 7.465,
    rx: 1.5,
    transform: "translate(22.578 85.471)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_536",
    "data-name": "L\\xEDnea 536",
    y2: 13.889,
    transform: "translate(36.746 71.467)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_834",
    "data-name": "Trazado 834",
    d: "M14.155,36.182h0c0,2.267,1.439,4.107,3.212,4.107h9.768c1.773,0,3.212-1.84,3.212-4.107",
    transform: "translate(14.495 37.05)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_835",
    "data-name": "Trazado 835",
    d: "M27.868,32.229h7.669a4.043,4.043,0,0,1,4.044,4.042V56.523",
    transform: "translate(28.537 33.002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_836",
    "data-name": "Trazado 836",
    d: "M2.655,56.523V36.273A4.043,4.043,0,0,1,6.7,32.229h6.509",
    transform: "translate(2.719 33.002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_780",
    "data-name": "Elipse 780",
    transform: "translate(0.089 -0.015)",
    fill: "none",
    stroke: "#6f2fd3",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 62,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b63287db8e4940ea41cec7e1ea3f6c64.svg";
export { ForwardRef as ReactComponent };